<template>
  <div class="content">
    <div class="filter">
      <el-input placeholder="请输入关键字(英文逗号分隔)" v-model.trim="input" style="width:300px" @change="searchPage" clearable @clear="handleClear">
        <el-select v-model="currentFilter" slot="prepend" placeholder="请选择" @change="handleChange" style="width:120px">
          <el-option label="需求编号" value="demandNos"></el-option>
          <el-option label="商品名称" value="productName"></el-option>
          <el-option label="用户ID" value="userIds"></el-option>
          <el-option label="用户名" value="userNames"></el-option>
        </el-select>
      </el-input>
      <el-select v-model="listParams.status" placeholder="需求状态" @change="initPage" clearable style="width:110px">
        <el-option label="未接收" :value="1"></el-option>
        <el-option label="已接收" :value="2"></el-option>
        <el-option label="已完成" :value="3"></el-option>
        <el-option label="已取消" :value="4"></el-option>
        <el-option label="已上架" :value="5"></el-option>
      </el-select>
      <el-select v-model="listParams.paymentStatus" placeholder="付款状态" @change="initPage" clearable style="width:120px">
        <el-option label="未发起收款" :value="0"></el-option>
        <el-option label="未支付" :value="1"></el-option>
        <el-option label="已支付" :value="2"></el-option>
        <el-option label="已取消" :value="3"></el-option>
      </el-select>
      <el-select v-model="listParams.firstOperators" clearable placeholder="对接人" @change="initPage" multiple collapse-tags>
        <el-option v-for="(item,index) in userManager" :key="index" :value="item.fullName" :label="item.fullName" />
      </el-select>
      <el-select v-model="listParams.satisfy" placeholder="是否满足" clearable @change="initPage" style="width:110px">
        <el-option label="否" :value="false"></el-option>
        <el-option label="是" :value="true"></el-option>
      </el-select>
      <el-select v-model="listParams.type" @change="initPage" style="width:110px" clearable placeholder="定制类型">
        <el-option label="COD" value="1"></el-option>
        <el-option label="POD" value="2"></el-option>
      </el-select>
      <el-select v-model="whichDate" @change="initPage" class="whichDateSelect" style="width:110px" >
        <el-option label="发起时间" value="createDate"></el-option>
        <el-option label="更新时间" value="modifyDate"></el-option>
      </el-select>
      <el-date-picker v-model="registerDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" :default-time="['00:00:00', '23:59:59']" @change="handleDatePick" style="margin-left:0px !important"></el-date-picker>
    </div>

    <el-table :data="customList" height="calc(100vh - 198px)" @sort-change="sortChange" v-loading="loading">
      <el-table-column prop="userId" label="图片" width="120">
        <template slot-scope="{row}">
          <el-popover placement="right" width="280" trigger="hover">
            <el-image :src="row.imageUrl" fit="cover" />
            <el-image slot="reference" :src="row.imageUrl" fit="cover" class="stock-img" style="width:80px;height:80px" />
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="productName" label="商品名称" width="150" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="demandNo" label="需求编号" width="150">
        <template slot-scope="scope">
          <el-link type="primary" @click="seeDetail(scope.row.id)">{{scope.row.demandNo}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="用户名" width="120"></el-table-column>
      <el-table-column prop="status" label="需求状态" width="120">
        <template slot-scope="{row}">
          <span>{{getStatus(row.status)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="satisfy" label="是否满足" width="130">
        <template slot-scope="{row}">
          <el-select v-model="row.satisfy" placeholder="请选择" @change="handleCustomStatus(row, 'satisfy')" style="width:110px">
            <el-option label="否" :value="false"></el-option>
            <el-option label="是" :value="true"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="paymentStatus" label="付款状态" width="120">
        <template slot-scope="{row}">
          <span>{{getPaymentStatus(row.paymentStatus)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="estimatedOrderQuantity" label="预计订货数量" width="160" sortable="custom"></el-table-column>
      <el-table-column prop="createDate" label="发起时间" sortable="custom" width="180"></el-table-column>
      <el-table-column prop="modifyDate" label="更新时间" sortable="custom" width="180"></el-table-column>
      <el-table-column prop="spu" label="SPU"></el-table-column>
      <el-table-column label="定制类型" width="270">
        <template slot-scope="scope">
          <div v-if="+scope.row.type === 1" style="width:100%" class="f--c">
            <div style="width:40px;height:40px;margin-right:4px;">
              <img :src="customizeOnDemandImage" style="width:40px;height:40px" />
            </div>
            <div>Customize on Demand</div>
          </div>
          <div v-else class="f--c">
            <div style="width:40px;height:40px;margin-right:4px;">
              <img src="https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/print_customize/PrintOnDemand.png" style="width:40px;height:40px" />
            </div>
            <div>Print on Demand</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="firstOperator" label="对接人" width="170">
        <template slot-scope="{row}">
          <el-select v-model="row.firstOperator" placeholder="对接人" @change="handleCustomStatus(row, 'firstOperator')" style="width:140px">
            <el-option v-for="(item,index) in userManager" :key="index" :value="item.fullName" :label="item.fullName" :title="item.fullName" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="seeDetail(row.id)" style="margin-right:15px">详情</el-button>
          <el-dropdown @command="command=>handleCommand(command,row)" trigger="click">
            <span class="el-dropdown-link">
              <el-button type="text" size="medium">更多</el-button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1" v-show="row.status===1">接收需求</el-dropdown-item>
              <!-- <el-dropdown-item :command="2" v-show="row.status===1||row.status===2">发起收款</el-dropdown-item> -->
              <el-dropdown-item :command="3" v-show="row.status!==5">收款记录</el-dropdown-item>
              <el-dropdown-item :command="4" v-show="row.status===2&&row.paymentStatus===2">完成需求</el-dropdown-item>
              <el-dropdown-item :command="5" v-show="row.status===3||row.status===5">关联商品</el-dropdown-item>
              <el-dropdown-item :command="6" v-show="row.status===1||row.status===2">创建订单</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <div class="f-b-c bg-white" style="padding: 10px">
      <div></div>
      <el-pagination background :current-page="listParams.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="listParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="sizeChange" @current-change="pageChange" />
    </div>
    <el-dialog title="收款记录" :visible.sync="paymentLogVisible" width="1000px" :before-close="resetPage">
      <el-table :data="paymentLogList" height="300px">
        <el-table-column prop="createDate" label="发起时间" width="160">
          <template slot-scope="{row}">
            <span>{{formateTime(row.createDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="paymentDate" label="收款时间" width="160">
          <template slot-scope="{row}">
            <span>{{formateTime(row.paymentDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sampleFee" label="收款金额" width="120">
          <template slot-scope="{row}">
            <span>US${{row.sampleFee}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="paymentStatus" label="付款状态" width="120">
          <template slot-scope="{row}">
            <span>{{getPaymentStatus(row.paymentStatus)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注">
          <template slot-scope="{row}">
            <span>{{row.remark}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="kkOrderId" label="kaka订单号" width="180">
          <template slot-scope="{row}">
            <el-link type="primary" @click="jumpOrder(row.kkOrderId)">{{ row.kkOrderId }}</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="发起收款" :visible.sync="paymentVisible" width="600px" :before-close="resetPage">
      <el-form ref="sampleForm" :model="sampleForm" label-width="80px" :rules="baseRules">
        <!-- <el-form-item label="类型" prop="type">
          <el-select v-model="sampleForm.type" size="medium" placeholder="请选择类型" style="width:120px">
            <el-option label="样品费" value="1"></el-option>
            <el-option label="运费" value="2"></el-option>
            <el-option label="大货" value="3"></el-option>
            <el-option label="操作费" value="4"></el-option>
            <el-option label="其他" value="5"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="总金额" prop="sampleFee">
          <el-input-number v-model="sampleForm.sampleFee" :min="0" size="medium"></el-input-number><span>USD</span>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="sampleForm.remark" clearable size="medium" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetPage">取 消</el-button>
        <el-button type="primary" @click="handleInitiatePayment">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="关联商品" :visible.sync="commodityVisible" width="600px" :before-close="resetPage">
      <el-form ref="spuForm" :model="spuForm" label-width="80px" :rules="baseRules">
        <el-form-item label="SPU" prop="spu">
          <el-input v-model="spuForm.spu" :min="0"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetPage">取 消</el-button>
        <el-button type="primary" @click="handleAssociationCommodity">确 定</el-button>
      </span>
    </el-dialog>

    <createOrder ref="createOrder" />
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import { dateFormat } from '@/utils/date'
import { PODImageMap, customizeOnDemandImage } from './data'
import createOrder from './components/createOrder.vue'
export default {
  components: { createOrder },
  name: 'service_customization',
  data() {
    return {
      registerDate: [],
      commodityVisible: false,
      paymentVisible: false,
      paymentLogVisible: false,
      paymentLogList: [],
      tabName: 'first',
      input: '',
      total: 0,
      managerTotal: 0,
      filterType: '1',
      listParams: {
        pageNumber: 1,
        pageSize: 20,
        paymentStatus: undefined,
        firstOperators: [],
        type: undefined
      },

      sampleForm: {},//样品费
      sampleFeeForm: {},//样品费
      roleForm: {
        roleList: [10]
      },
      spuForm: {},
      commodityForm: {},
      userManager: [],//对接人
      currentFilter: 'productName',
      customList: [],//定制列表
      baseRules: {
        type: [{ required: true, message: '请选择类型', trigger: 'change' },],
        sampleFee: [{ required: true, message: '请输入样品费', trigger: 'blur' },],
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' },],
        spu: [{ required: true, message: '请输入要关联的SPU', trigger: 'blur' },]
      },
      whichDate: 'createDate',
      loading: false,
      customizeOnDemandImage
    }
  },
  created() {
    this.getStorageParams()
    this.getCustomList()
    this.getUserInfoSelect()

    this.isSuperAdministrator = this.$store.getters.userRole == 4
  },
  filters: {
    podStyleImage(value) {
      const target = PODImageMap.find(e => +e.value === +value)
      return target.url
    },
    podStyleText(value) {
      const target = PODImageMap.find(e => +e.value === +value)
      return target.text
    }
  },
  computed: {
    getStatus() {
      return (statu) => {
        switch (statu) {
          case 1:
            return '未接收'
          case 2:
            return '已接收'
          case 3:
            return '已完成'
          case 4:
            return '已取消'
          case 5:
            return '已上架'
        }
      }
    },
    getPaymentStatus() {
      return (statu) => {
        switch (statu) {
          case 0:
            return '未发起收款'
          case 1:
            return '未支付'
          case 2:
            return '已支付'
          case 3:
            return '已取消'
        }
      }
    }
  },
  methods: {
    getCustomList() {
      this.loading = true
      this.$store.commit('setState', { key: 'customizationGetListParams', value: this.listParams })
      const params = Object.assign({}, this.listParams)
      if (this.registerDate && this.registerDate.length) {
        params[`${this.whichDate}Start`] = this.registerDate[0]
        params[`${this.whichDate}End`] = this.registerDate[1]
      }
      Object.keys(params).forEach(key => {
        if (!params[key] && key !== 'paymentStatus' && key !== 'satisfy') params[key] = undefined
      })
      Object.keys(params).forEach(item => {
        if (['demandNos', 'productName', 'userIds', 'userNames'].includes(item)) {
          this.input = params[item]?params[item].toString():''
        }
      })
      API.getCustomList(params).then(res => {
        this.customList = _.get(res, 'data.list', [])
        this.total = res.data.total
        this.customList.forEach(item => {
          item.modifyDate = dateFormat(item.modifyDate)
          item.createDate = dateFormat(item.createDate)
        })
        this.$tableScrollTop()
      }).finally(() => {
        this.loading = false
      })
    },

    resetPage() {
      this.sampleForm = {},
        this.spuForm = {}
      this.paymentVisible = false
      this.paymentLogVisible = false
      this.commodityVisible = false
    },
    handleClear() {
      this.listParams = {
        pageNumber: 1,
        pageSize: 20,
      },
        this.getCustomList()
    },

    //接收需求
    receiveDemand(row) {
      this.$confirm('请确定是否接收该定制需求?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let { id, userId, userName } = row
        let form = { id, userId, userName, operationType: 1, }
        this.getEditCustomStatus(form)
      })
    },
    //完成需求
    finishDemand(row) {
      this.$confirm('请确定是否完成该定制需求?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let { id, userId, userName } = row
        let form = { id, userId, userName, operationType: 4, }
        this.getEditCustomStatus(form)
      })
    },
    //修改状态接口
    getEditCustomStatus(form) {
      API.getEditCustomStatus(form).then(res => {
        if (res.code === 10000) {
          this.$message.success('操作需求成功')
          this.getCustomList()
          this.resetPage()
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.$message.error(err.data.message)
      })
    },

    //关联产品
    associationCommodity(row) {
      this.commodityVisible = true
      let { id, userId, userName } = row
      this.commodityForm = { id, userId, userName, operationType: 5 }
    },
    handleAssociationCommodity() {
      this.$refs.spuForm.validate((valid) => {
        if (!valid) return
        this.commodityForm.spu = this.spuForm.spu
        this.getEditCustomStatus(this.commodityForm)
      });
    },

    handleCommand(command, row) {
      if (command === 3) return this.handlePaymentLogOpen(row.demandNo)
      if (command === 2) return this.handlePaymentOpen(row)
      if (command === 1) return this.receiveDemand(row)
      if (command === 4) return this.finishDemand(row)
      if (command === 5) return this.associationCommodity(row)
      if (command === 6) return this.$refs.createOrder.show(row)
    },

    //收款记录
    handlePaymentLogOpen(demandNo) {
      this.paymentLogVisible = true
      let form = { demandNo: demandNo }
      this.getPaymentLogList(form)
    },

    getPaymentLogList(form) {
      API.getPaymentLogList(form).then(res => {
        this.paymentLogList = res.data || []
      })
    },
    formateTime(str) {
      if (str) {
        var oDate = new Date(str)
        var oYear = oDate.getFullYear()
        var oMonth = oDate.getMonth() + 1
        var oDay = oDate.getDate()
        var oHour = oDate.getHours()
        var oMin = oDate.getMinutes()
        var oSec = oDate.getSeconds()
        var oTime = ''
        oTime = oYear + '-' + this.getzf(oMonth) + '-' + this.getzf(oDay) + ' ' + this.getzf(oHour) + ':' + this.getzf(oMin) + ':' + this.getzf(oSec)// 最后拼接时间
        return oTime
      } else {
        return '-'
      }
    },
    // 补0操作
    getzf(num) {
      if (parseInt(num) < 10) {
        num = '0' + num
      }
      return num
    },

    //发起收款
    handlePaymentOpen(row) {
      this.paymentVisible = true
      let { id, userId, userName } = row
      this.sampleFeeForm = { id, userId, userName, operationType: 2, }
    },

    //确认发起收款
    handleInitiatePayment() {
      this.$refs.sampleForm.validate((valid) => {
        if (!valid) return
        this.sampleFeeForm.sampleFee = this.sampleForm.sampleFee
        this.sampleFeeForm.remark = this.sampleForm.remark
        this.getEditCustomStatus(this.sampleFeeForm)
      })
    },

    //详情
    seeDetail(id) {
      this.$router.push({
        path: '/service/customization/detail',
        query: {
          id: id
        }
      })
    },

    //对接人列表
    getUserInfoSelect() {
      API.getUserInfoSelect(this.roleForm).then(res => {
        this.userManager = res.data
      })
    },
    //切换筛选条件
    handleChange(value) {
      this.currentFilter = value
      this.input = ''
      this.initPage()
    },

    searchPage() {
      if (this.listParams.demandNos) delete this.listParams.demandNos
      if (this.listParams.productName) delete this.listParams.productName
      if (this.listParams.userIds) delete this.listParams.userIds
      if (this.listParams.userNames) delete this.listParams.userNames
      if (this.currentFilter === 'productName') {
        this.listParams[this.currentFilter] = this.input
      } else {
        this.listParams[this.currentFilter] = this.input.split(',')
      }
      this.initPage()
    },
    initPage() {
      this.listParams.pageNumber = 1
      this.getCustomList()
    },

    //时间筛选
    handleDatePick() {
      // if (value && value.length === 2) {
      //   if(this.whichDate === 'createDate')
      //   this.listParams.createDateStart = value[0]
      //   this.listParams.createDateEnd = value[1]
      // } else {
      //   this.listParams.createDateStart = undefined
      //   this.listParams.createDateEnd = undefined
      // }
      this.initPage()
    },

    listedProduct(row) {
      this.$router.push({ path: '/supply/goods/goods', params: { id: row.kkProductId } })
    },
    sizeChange(size) {
      this.listParams.pageSize = size
      this.getCustomList()
    },
    pageChange(page) {
      this.listParams.pageNumber = page
      this.getCustomList()
    },
    getStorageParams() {
      Object.keys(this.$store.state.customizationGetListParams).forEach(key => {
        if (this.$store.state.customizationGetListParams[key]) {
          this.listParams[key] = this.$store.state.customizationGetListParams[key]
        }
      })
    },
    sortChange({ column, prop, order }) {
      console.log(column, prop, order)
      switch (prop) {
        case 'estimatedOrderQuantity':
          if (order === 'ascending') {
            this.listParams.sortType = 6
          } else if (order === 'descending') {
            this.listParams.sortType = 5
          } else {
            this.listParams.sortType = undefined
          }
          break;
        case 'createDate':
          if (order === 'ascending') {
            this.listParams.sortType = 4
          } else if (order === 'descending') {
            this.listParams.sortType = 3
          } else {
            this.listParams.sortType = undefined
          }
          break;
        case 'modifyDate':
          if (order === 'ascending') {
            this.listParams.sortType = 2
          } else if (order === 'descending') {
            this.listParams.sortType = 1
          } else {
            this.listParams.sortType = undefined
          }
          break;
        default:
          break;
      }
      this.initPage()
    },
    handleCustomStatus(row, type) {
      console.log(row)
      let { id, userId, userName } = row
      let form = { id, userId, userName, operationType: 7 }
      form[type] = row[type]
      this.getEditCustomStatus(form)
    },

    jumpOrder(id) {
      this.paymentLogVisible = false
      this.$router.push(`/orders/all-orders/order-details?id=${id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  background: #ffffff;
  padding: 12px 12px 0;
  .filter {
    padding: 12px;
    & > div {
      margin-left: 12px;
    }
    /deep/.el-input-group {
      width: 300px;
    }
    /deep/.el-input-group__prepend {
      width: 100px;
    }
  }
}
.range-num {
  display: inline-block;
  margin-right: 16px;
}
.update-time {
  display: inline-block;
  margin: 0 16px;
}

.avatar {
  width: 178px;
  height: 178px;
  object-fit: cover;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
/deep/.el-range-separator {
  min-width: 20px;
}
.whichDateSelect {
  /deep/.el-input__inner {
    border-right: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}
</style>>
